export const get_percentage = (val, total) => {
  return parseFloat((val / total) * 100).toFixed(2);
};
